import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import StaffsTable from '../StaffsTable';

const AllStaffList = ({
  handleViewDetail,
  toggleAddRecord,
  handleDelete,
  searchString,
}) => {
  return (
    <div>
      {' '}
      <ErrorBoundary>
        <StaffsTable
          handleViewDetail={handleViewDetail}
          toggleAddRecord={toggleAddRecord}
          handleDelete={handleDelete}
          searchString={searchString}
          satffType="TRADER"
          op="NOT_IN"
        />
      </ErrorBoundary>
    </div>
  );
};

export default AllStaffList;
